import { ReactNode } from "react";

import { FormattedMessage, MessageDescriptor } from "react-intl";

import Heading from "@atlaskit/heading";
import { Box, Stack, Text, xcss } from "@atlaskit/primitives-next";

const iconBorderStyles = xcss({
    height: "32px",
    width: "32px",
    padding: "space.050",
    // border
    border: "1.5px",
    borderRadius: "6px",
    borderStyle: "solid",
    borderColor: "color.border.disabled"
});

export const FeatureBox = ({
    heading,
    description,
    icon
}: {
    heading: MessageDescriptor;
    description: MessageDescriptor;
    icon: ReactNode;
}) => {
    return (
        <Box padding="space.200">
            <Stack space="space.200" alignInline="start">
                <Stack
                    xcss={iconBorderStyles}
                    alignBlock="center"
                    alignInline="center"
                    grow="fill"
                >
                    {icon}
                </Stack>

                <Stack space="space.050">
                    <Heading size="small">
                        <FormattedMessage {...heading} />
                    </Heading>
                    <Text size="small">
                        <FormattedMessage {...description} />
                    </Text>
                </Stack>
            </Stack>
        </Box>
    );
};
